import { render, staticRenderFns } from "./priceLabsView.vue?vue&type=template&id=5cecfc9e&scoped=true&"
import script from "./priceLabsView.vue?vue&type=script&lang=js&"
export * from "./priceLabsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecfc9e",
  null
  
)

export default component.exports